/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import ProfileStore from './stores/profileStore';
import get from 'lodash/get';
import forOwn from 'lodash/forOwn';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import isNaN from 'lodash/isNaN';
import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import cloneDeep from 'lodash/cloneDeep';
import slug from 'slug';

const zeroDecimalCurrencies = [
    'bif',
    'djf',
    'jpy',
    'krw',
    'pyg',
    'vnd',
    'xaf',
    'xpf',
    'clp',
    'gnf',
    'kmf',
    'mga',
    'rwf',
    'vuv',
    'xof'
];

const debug = (...args) => {
    if (process.env.NODE_ENV === 'development') console.log(...args);
};

const env = process.env.REACT_APP_SETTINGS_ENV || process.env.NODE_ENV;

const config = {
    development: {
        protocol: 'https:',
        port: 443,
        domain: 'fxservicesdevelop.nunchee.com',
        env: env
    },
    staging: {
        protocol: 'https:',
        port: 443,
        domain: 'fxservicesstaging.nunchee.com',
        env: env
    },
    production: {
        protocol: 'https:',
        port: 443,
        domain: 'services.nunchee.tv',
        env: env
    },
};

/**
 * Check if the user has permissions for a operation
 */
const can = (operation, permission) => {
    if (ProfileStore.isRoot) return true;

    if (
        permission === 'products' ||
        permission === 'plans' ||
        permission === 'appbuilder' ||
        permission === 'storepresence'
    ) {
        const template = get(ProfileStore, 'session.user.rbac.template');
        if (template === 'Admin' || template === 'custom') return true;
        return false;
    }
    const permissions = get(ProfileStore, 'session.user.rbac.permissions', {});
    const operations = get(permissions, `${permission}.operations`, []);
    return operations.indexOf(operation) >= 0;
};

const formatPrice = (price, currency, operator = '') => {
    if (operator === 'mul') {
        if (zeroDecimalCurrencies.indexOf(currency) > -1) return (price * 1);
        return Number((price * 100).toFixed(2));
    } else {
        if (zeroDecimalCurrencies.indexOf(currency) > -1) return (price * 1).toFixed(2);
        return (price / 100).toFixed(2);
    }
}

const getMobileOperatingSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        return 'android';
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios';
    }
    return 'desktop';
};

const isValidObjetID = str => /^[0-9A-Fa-f]{24}$/.test(str);

const cleanObject = (obj, filter) => {
    return (function remove(current) {
        forOwn(current, (value, key) => {
            if (
                (filter.undefined && isUndefined(value)) ||
                (filter.null && isNull(value)) ||
                (filter.NaN && isNaN(value)) ||
                (filter.emptyString && isString(value) && isEmpty(value)) ||
                (isObject(value) && isEmpty(remove(value)))
            ) {
                delete current[key];
            }
        });

        return current;
    })(cloneDeep(obj));
};

const slugProcessor = code => {
    return slug(code, { remove: /[._~]/g, lower: true, replacement: '' }).replace(/(^\d+)/, 'code$1');
};

const generateRandom = (n = 8, specialCharacters = true) => {
    const charset = (specialCharacters) ?
        '!"#$%&\'()*+,-./:;<=>?@[]\\^_`{|}~abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789' :
        'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let str = '';

    for (let i = 0; i < n; i++)
        str += charset.charAt(Math.floor(Math.random() * charset.length));

    return str;
};

const getServicesConfig = (key) => {
    if (!key) {
        return config?.[env]
    } else if (key === 'url') {
        return config?.[env]?.protocol + '//' + config?.[env]?.domain
    } else {
        return config?.[env]?.[key]
    };
};

const imageUrl = (id, type = 'backdrop', scale = 100) => {
    return `/api/assets/images/view/${id}?type=${type}&scale=${scale}&placeholder=true`;
};

export { debug, can, formatPrice, getMobileOperatingSystem, isValidObjetID, cleanObject, slugProcessor, generateRandom, getServicesConfig, imageUrl };
